// src/hooks/useDetectClickOutsideComponent.ts
import { useEffect } from "react";
var useDetectClickOutsideComponent = function useDetectClickOutsideComponent(ref, setIsOptionListShown, isCondition, triggerRef) {
  useEffect(function () {
    if (isCondition) {
      var handleClickOutside = function handleClickOutside(event) {
        if (!ref) {
          return;
        }
        var node = ref.current;
        if (node && !node.contains(event.target) && setIsOptionListShown && (!triggerRef || !triggerRef.current || !triggerRef.current.contains(event.target))) {
          setIsOptionListShown(false);
        }
      };
      document.addEventListener("mouseup", handleClickOutside);
      return function () {
        document.removeEventListener("mouseup", handleClickOutside);
      };
    }
    return function () {};
  }, [ref, setIsOptionListShown, isCondition, triggerRef]);
};
export { useDetectClickOutsideComponent };